module.exports = "/images/vendor/svg-country-flags/svg/pl.svg?e2978cd583d46dfe1682d0f83fdc3f59";